import React, { PureComponent } from 'react';

import { Edit as EditIcon, Delete as DeleteIcon, Group as GroupIcon } from '@mui/icons-material';

import { Button, IconButton, Tooltip, Zoom } from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../../common/components/TableEnhanced/TableEnhancedContainer';
import ConfirmationDialog from '../../../../common/components/ConfirmationDialog/ConfirmationDialog';
import CreationDialog from '../CreationDialog/CreationDialog';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';

class GroupsManager extends PureComponent {
  constructor(props) {
    super(props);
    this.columnsConfig = [
      {
        name: 'Name',
        key: 'Name',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'No of users',
        key: 'NrOfUsersInGroup',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'No of instruments',
        key: 'NrOfInstrumentsInGroup',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          return (
            <div>
              <Tooltip disableInteractive TransitionComponent={Zoom} title="Edit">
                <IconButton
                  size="large"
                  key={1}
                  onClick={() => {
                    return props.onEditCallback(el);
                  }}
                  data-qa="qa-edit-group"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
                <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                  <IconButton
                    size="large"
                    key={2}
                    onClick={() => {
                      return props.onDeleteCallback(el);
                    }}
                    data-qa="qa-delete-group"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </PermissionsCheck>
            </div>
          );
        },
        style: { width: '10rem' },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];
  }

  render() {
    return (
      <Tile
        title={this.props.groupTileTitle}
        TitleIcon={GroupIcon}
        helpTag="regions_and_groups-groups"
        RightContent={
          <div>
            <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
              <Button
                variant="contained"
                data-qa="qa-addNewGroup"
                className="u-ml-double"
                color="primary"
                onClick={this.props.onAddGroup}
              >
                Add group
              </Button>
            </PermissionsCheck>
          </div>
        }
      >
        <ConfirmationDialog
          onClickCancel={this.props.showConfirmDialog.cancel}
          onClickMainAction={this.props.showConfirmDialog.action}
          open={this.props.showConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirm}
          title={this.props.showConfirmDialog.title}
          mainActionLabel={this.props.showConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showConfirmDialog.disableMainAction}
        />

        <CreationDialog
          onClickCancel={this.props.showDialog.cancel}
          onClickMainAction={this.props.showDialog.action}
          open={this.props.showDialog.show}
          title={this.props.showDialog.title}
          disableMainAction={
            !(this.props.errorGroupName === '' && this.props.groupName && !this.props.isSaving)
          }
          textfieldName={'Group name'}
          errorText={this.props.errorGroupName}
          onChangeCallback={this.props.onChangeCallback}
          propertyToEdit={'Name'}
        />

        <TableEnhancedContainer
          data={this.props.data}
          columns={this.columnsConfig}
          enableHideColumns={false}
          enableActionButtons={false}
        />
      </Tile>
    );
  }
}

export default GroupsManager;
